var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38948 0.210274C7.66985 -0.0700914 8.12441 -0.0700914 8.40477 0.210274L11.2765 3.08196C11.5568 3.36232 11.5568 3.81689 11.2765 4.09725L8.40477 6.96893C8.12441 7.2493 7.66985 7.2493 7.38948 6.96893C7.10912 6.68857 7.10912 6.23401 7.38948 5.95364L9.0356 4.30752H0.717921C0.321424 4.30752 0 3.9861 0 3.5896C0 3.19311 0.321424 2.87168 0.717921 2.87168H9.0356L7.38948 1.22557C7.10912 0.945202 7.10912 0.49064 7.38948 0.210274Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrow);
export default __webpack_public_path__ + "static/media/forwardArrow.b63678146db6f628512114f9df85e1f3.svg";
export { ForwardRef as ReactComponent };